import { getCurrentInstance } from '@vue/composition-api'

export const can = (action, subject) => {
  const vm = getCurrentInstance().proxy

  return vm.$can ? vm.$can(action, subject) : true
}

export const canViewVerticalNavMenuLink = item => can(item.action, item.resource)

// eslint-disable-next-line arrow-body-style
export const canViewVerticalNavMenuGroup = item => {
  const hasAnyVisibleChild = item.children.some(i => can(i.action, i.resource))

  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild
  }

  return can(item.action, item.resource) && hasAnyVisibleChild
}

export const canViewVerticalNavMenuHeader = item => can(item.action, item.resource)

export const canViewHorizontalNavMenuLink = item => can(item.action, item.resource)

export const canViewHorizontalNavMenuHeaderLink = item => can(item.action, item.resource)

// eslint-disable-next-line arrow-body-style
export const canViewHorizontalNavMenuGroup = item => {
  const hasAnyVisibleChild = item.children.some(i => can(i.action, i.resource))

  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild
  }

  return can(item.action, item.resource) && hasAnyVisibleChild
}

// eslint-disable-next-line arrow-body-style
export const canViewHorizontalNavMenuHeaderGroup = item => {

  // eslint-disable-next-line arrow-body-style
  const hasAnyVisibleChild = item.children.some(grpOrItem => {
    return grpOrItem.children ? canViewHorizontalNavMenuGroup(grpOrItem) : canViewHorizontalNavMenuLink(grpOrItem)
  })

  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild
  }

  return can(item.action, item.resource) && hasAnyVisibleChild
}
